/* src/app/private/components/admission/move-to-student/move-to-student.component.scss */
label {
  font-weight: 600;
  margin-bottom: 10px;
}
.requiredValue::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=move-to-student.component.css.map */
